module.exports = __webpack_public_path__ + "static/img/4279_phase_function_Paper_Points.3d9c069.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4279_phase_function_Paper_Points.png
// module id = ceXL
// module chunks = 0